import React from "react";
import { Playlists } from "./playlist/playlists";
import clsx from "clsx";
import { SongSearch } from "./songSearch/songSearch";
import { PlaylistView } from "./playlist/playlistView";
import { activeMusicManagerView } from "../state/musicManager";
import { HistoryView } from "./songSearch/history";
import {TagFrequencyView} from "./tagFrequencyView";

export function MusicManager() {
  return (
    <div className="md:h-full md:max-h-full overflow-hidden flex">
      <Playlists />
      <div className="h-full flex-[1]">
        <div className={clsx("grid grid-cols-1 md:h-full md:max-h-full")}>
          {activeMusicManagerView.value === "history" ? (
            <HistoryView />
          ) : activeMusicManagerView.value === "playlist" ? (
            <PlaylistView />
          ) : activeMusicManagerView.value === "tagFrequency" ? (
            <TagFrequencyView />
          ) : (
            <SongSearch />
          )}
        </div>
      </div>
    </div>
  );
}
